import { __extends } from "tslib";
import { PutObjectAclOutput, PutObjectAclRequest } from "../models/models_0";
import { deserializeAws_restXmlPutObjectAclCommand, serializeAws_restXmlPutObjectAclCommand, } from "../protocols/Aws_restXml";
import { getBucketEndpointPlugin } from "@aws-sdk/middleware-bucket-endpoint";
import { getSerdePlugin } from "@aws-sdk/middleware-serde";
import { Command as $Command } from "@aws-sdk/smithy-client";
var PutObjectAclCommand = /** @class */ (function (_super) {
    __extends(PutObjectAclCommand, _super);
    // Start section: command_properties
    // End section: command_properties
    function PutObjectAclCommand(input) {
        var _this = 
        // Start section: command_constructor
        _super.call(this) || this;
        _this.input = input;
        return _this;
        // End section: command_constructor
    }
    PutObjectAclCommand.prototype.resolveMiddleware = function (clientStack, configuration, options) {
        this.middlewareStack.use(getSerdePlugin(configuration, this.serialize, this.deserialize));
        this.middlewareStack.use(getBucketEndpointPlugin(configuration));
        var stack = clientStack.concat(this.middlewareStack);
        var logger = configuration.logger;
        var clientName = "S3Client";
        var commandName = "PutObjectAclCommand";
        var handlerExecutionContext = {
            logger: logger,
            clientName: clientName,
            commandName: commandName,
            inputFilterSensitiveLog: PutObjectAclRequest.filterSensitiveLog,
            outputFilterSensitiveLog: PutObjectAclOutput.filterSensitiveLog,
        };
        if (typeof logger.info === "function") {
            logger.info({
                clientName: clientName,
                commandName: commandName,
            });
        }
        var requestHandler = configuration.requestHandler;
        return stack.resolve(function (request) {
            return requestHandler.handle(request.request, options || {});
        }, handlerExecutionContext);
    };
    PutObjectAclCommand.prototype.serialize = function (input, context) {
        return serializeAws_restXmlPutObjectAclCommand(input, context);
    };
    PutObjectAclCommand.prototype.deserialize = function (output, context) {
        return deserializeAws_restXmlPutObjectAclCommand(output, context);
    };
    return PutObjectAclCommand;
}($Command));
export { PutObjectAclCommand };
//# sourceMappingURL=PutObjectAclCommand.js.map